import React, { useEffect, useState } from "react";
import Post from "./Post";
import "./blogs.scss";
import { getAllPosts } from "./API.js";

const Blogs = () => {
  const [posts, setposts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      let data = await getAllPosts();
      console.log(data);
      setposts(data);
    };

    fetchData();
  }, []);

  return (
    <div className="posts">
      {posts.map((post) => (
        <Post post={post} />
      ))}
    </div>
  );
};

export default Blogs;
